
export default function alphaSort(objArray, field) {
  return objArray.sort((a, b) => {
    return a[field].localeCompare(b[field]);
  });
}